import React from 'react';
import { useTranslation } from 'react-i18next';
import { Send, Mail, Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export default function AdminConfig({ configForm, setConfigForm, handleUpdateConfig, testEmail, setTestEmail, sendingTest, handleSendTestEmail }) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="config-tab">
      <Card className="border-0 shadow-lg">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Send className="h-5 w-5 text-fuchsia-600" />Test Email SMTP (Brevo)</CardTitle>
          <CardDescription>Les identifiants SMTP sont configurés via les variables d'environnement (SMTP_HOST, SMTP_PORT, SMTP_LOGIN, SMTP_PASSWORD).</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div className="p-3 bg-zinc-50 rounded-lg space-y-1 text-sm text-zinc-600">
              <p><strong>Serveur :</strong> Brevo (smtp-relay.brevo.com)</p>
              <p><strong>Port :</strong> 587</p>
              <p className="text-xs text-zinc-400 mt-2">Modifiable dans les System Keys de la plateforme</p>
            </div>
            <div className="space-y-2 p-4 bg-fuchsia-50 rounded-lg border border-fuchsia-200">
              <Label className="font-semibold text-zinc-900">Adresse d'expédition (From)</Label>
              <p className="text-xs text-zinc-500">Les emails envoyés par le site afficheront cette adresse comme expéditeur.</p>
              <Input type="email" value={configForm.smtp_from_email || ''} onChange={(e) => setConfigForm({...configForm, smtp_from_email: e.target.value})} placeholder="contact@briouso-folies.fr" data-testid="smtp-from-email-input" />
            </div>
            <div className="space-y-2 p-4 bg-fuchsia-50 rounded-lg border border-fuchsia-200">
              <Label className="font-semibold text-zinc-900">Adresse de réception du formulaire de contact</Label>
              <p className="text-xs text-zinc-500">Les messages du formulaire de contact seront envoyés à cette adresse.</p>
              <Input type="email" value={configForm.contact_recipient_email || ''} onChange={(e) => setConfigForm({...configForm, contact_recipient_email: e.target.value})} placeholder="reception@briouso-folies.fr" data-testid="contact-recipient-email-input" />
            </div>
            <Button type="button" onClick={handleUpdateConfig} className="w-full bg-fuchsia-600 hover:bg-fuchsia-700" data-testid="save-email-config-btn">Enregistrer la configuration email</Button>
            <form onSubmit={handleSendTestEmail} className="space-y-4 pt-4 border-t">
              <div><Label>Envoyer un email de test à :</Label><Input type="email" value={testEmail} onChange={(e) => setTestEmail(e.target.value)} placeholder="votre-email@exemple.fr" required data-testid="test-email-input" /></div>
              <Button type="submit" className="w-full bg-fuchsia-600 hover:bg-fuchsia-700" disabled={sendingTest} data-testid="test-email-button">
                {sendingTest ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" />Envoi en cours...</> : <><Send className="h-4 w-4 mr-2" />Envoyer un email de test</>}
              </Button>
            </form>
          </div>
        </CardContent>
      </Card>
      <Card className="border-0 shadow-lg">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Mail className="h-5 w-5 text-fuchsia-600" />Configuration API</CardTitle>
          <CardDescription>Paramètres Mailchimp et Brevo API</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleUpdateConfig} className="space-y-6">
            <div className="space-y-4">
              <h3 className="font-semibold text-zinc-900 flex items-center gap-2"><div className="h-2 w-2 rounded-full bg-lime-600"></div>Mailchimp</h3>
              <div className="grid grid-cols-2 gap-4">
                <div><Label>API Key</Label><Input value={configForm.mailchimp_api_key || ''} onChange={(e) => setConfigForm({...configForm, mailchimp_api_key: e.target.value})} placeholder="xxxxxxxx-us1" /></div>
                <div><Label>List ID</Label><Input value={configForm.mailchimp_list_id || ''} onChange={(e) => setConfigForm({...configForm, mailchimp_list_id: e.target.value})} placeholder="abc123def456" /></div>
              </div>
            </div>
            <div className="space-y-4 pt-4 border-t">
              <h3 className="font-semibold text-zinc-900 flex items-center gap-2"><div className="h-2 w-2 rounded-full bg-indigo-600"></div>Brevo API (ex-Sendinblue)</h3>
              <div><Label>API Key</Label><Input value={configForm.brevo_api_key || ''} onChange={(e) => setConfigForm({...configForm, brevo_api_key: e.target.value})} placeholder="xkeysib-..." /></div>
            </div>
            <Button type="submit" className="w-full bg-fuchsia-600 hover:bg-fuchsia-700">Enregistrer la configuration</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
